import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getCourseById, getCourseByIdNoAuth } from "../../actions/course";
import { getPurchases } from "../../actions/purchase";
import { getProfileById } from "../../actions/profile";

import ReportUser from "../layout/IME/ReportUser";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import PurchaseCourse from "../layout/IME/PurchaseCourse";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import MentorCourseVideo from "../layout/Mentors/MentorCourseVideo";
import CourseComments from "../layout/Mentors/CourseComments";
import CourseVideos from "../layout/Mentors/CourseVideos";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import MentorChatRules from "../layout/Mentors/MentorChatRules";
import MentorStreamSchedule from "../layout/Mentors/MentorStreamSchedule";
import AboutMentor from "../layout/Mentors/AboutMentor";
import MentorSocial from "../layout/Mentors/MentorSocial";
import Approvals from "../layout/Mentors/Approvals";
import GiftCourse from "../layout/IME/GiftCourse";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import RedSpinner from "../../img/Red_Spinner.gif";

const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBILC_KEY;

const stripePromise = loadStripe(STRIPE_KEY);

const Course = ({
  match,
  auth: { isAuthenticated, user, channelid, jobtitle, location, verified },
  profile: { profile },
  getCourseById,
  getCourseByIdNoAuth,
  getProfileById,
  getPurchases,
  course: { course, coursevideo, loading },
  purchase: { purchases },
}) => {
  const [purchaseCourse, setShowPurchaseCourse] = useState(false);
  const [giftCourse, setShowGiftCourse] = useState(false);
  const [showChat, setShowChat] = useState(true);
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [text, setText] = useState("");

  useEffect(() => {
    getProfileById(match.params.channelid);
    getPurchases();
  }, [getProfileById, getPurchases, match.params]);

  useEffect(() => {
    if (isAuthenticated) {
      getCourseById(match.params.channelid, match.params.course_id);
    }

    if (!isAuthenticated) {
      getCourseByIdNoAuth(match.params.channelid, match.params.course_id);
    }
  }, []);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {/* <ReportUser /> */}
      {purchaseCourse && (
        <Elements stripe={stripePromise}>
          <PurchaseCourse
            course={course}
            setShowPurchaseCourse={setShowPurchaseCourse}
          />
        </Elements>
      )}
      {giftCourse && (
        <Elements stripe={stripePromise}>
          <GiftCourse course={course} setShowGiftCourse={setShowGiftCourse} />
        </Elements>
      )}
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavRed />}
      {!isAuthenticated && <LoggedOutNav />}
      {loading ? (
        <div className="profile-error">
          <img src={RedSpinner} alt="profile-red-spinner" />
        </div>
      ) : (
        <div className={showChat ? "flex-only-alt" : "flex-no-chat"}>
          <div className="side-container border-right grey">
            <div className="container-name red">
              <p className="container-title red bold">Course Content</p>
            </div>
            {course.coursesections &&
              course.coursesections.map((section) => {
                return (
                  <CourseVideos
                    section={section}
                    key={section._id}
                    course={course}
                    id={match.params.course_id}
                  />
                );
              })}
          </div>
          <div className="main-stream-content">
            <div className="video-chat">
              <MentorCourseVideo coursevideo={coursevideo} course={course} />
              {!showChat && (
                <div className="showchaticon" onClick={() => setShowChat(true)}>
                  <i className="far fa-comment fa-2x red"></i>
                </div>
              )}
            </div>
            <div className="information-attachments">
              <div className="information-section">
                <div className="stream-information-container">
                  <div className="stream-info-grid">
                    <div className="stream-grid-container">
                      <div className="stream-info">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${course.avatar}`}
                          className="streamer-user-avi"
                        />
                        <div className="helper-container">
                          <p className="stream-description">
                            {course.coursetitle}
                          </p>
                          <div className="stream-lower-info-alt">
                            <ul className="creator-stream-items">
                              <li className="stream-item red bold">
                                {course.channelid}
                              </li>
                              <li className="stream-item">
                                {course.firstname} {course.lastname}
                              </li>
                              <li className="stream-item">{course.jobtitle}</li>
                              <li className="stream-item">
                                <i className="far fa-clock mr-5 red"></i>
                                <Moment format="MM/DD/YYYY">
                                  {course.date}
                                </Moment>
                              </li>
                            </ul>
                            <ul className="user-count-items">
                              <li className="user-count-item">
                                <i className="fas fa-user-friends fa-lg mr-5 red"></i>
                                <span className="red mr-5 bold">Friends</span>
                                <span className="red bold">552</span>
                              </li>
                              <li className="user-count-item">
                                <i className="fas fa-user-check fa-lg mr-5 red"></i>
                                <span className="red mr-5 bold">
                                  Subscribers
                                </span>
                                <span className="red bold">5,852</span>
                              </li>
                              <li className="user-count-item">
                                <i className="fas fa-check fa-lg mr-5 red"></i>
                                <span className="red mr-5 bold">Followers</span>
                                <span className="red bold">5,852</span>
                              </li>
                            </ul>
                            <div className="action-buttons">
                              {isAuthenticated && (
                                <div className="action-items-stream">
                                  <div className="action-button red">
                                    <i className="far fa-thumbs-up action-icon fa-lg"></i>
                                  </div>
                                  <p className="action-text">5,768</p>
                                </div>
                              )}
                              {isAuthenticated && (
                                <div className="action-items-stream">
                                  <div className="action-button red">
                                    <i className="far fa-thumbs-down action-icon fa-lg"></i>
                                  </div>
                                </div>
                              )}
                              <div className="action-items-stream">
                                <div className="action-button red">
                                  <i className="far fa-user action-icon-alt-two fa-lg"></i>
                                </div>
                                <p className="action-text">5,768</p>
                              </div>
                              {isAuthenticated && (
                                <div className="action-items-stream">
                                  <div className="action-button red">
                                    <i className="far fa-share-square action-icon fa-lg"></i>
                                  </div>
                                  <p className="action-text">Share</p>
                                </div>
                              )}
                              {isAuthenticated && (
                                <div className="action-items-stream">
                                  <div className="action-button red">
                                    <i className="fas fa-donate action-icon fa-lg"></i>
                                  </div>
                                  <p className="action-text">Donate</p>
                                </div>
                              )}
                              {isAuthenticated && (
                                <div className="action-items-stream">
                                  <div className="action-button red">
                                    <i className="fas fa-check action-icon fa-lg"></i>
                                  </div>
                                  <p className="action-text">Follow</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="stream-grid-container-alt">
                      {isAuthenticated &&
                        purchases &&
                        purchases.length > 0 &&
                        purchases.map((purchase) => {
                          if (
                            purchase.purchase_id === course._id &&
                            purchase.purchaser_channelid != user.channelid
                          ) {
                            return (
                              <div className="action-items-stream-alt">
                                <div className="action-button red">
                                  <i className="fas fa-bag-shopping action-icon-alt fa-lg"></i>
                                </div>
                                <p className="action-text">Course Purchased</p>
                              </div>
                            );
                          }
                        })}
                      {isAuthenticated &&
                        purchases &&
                        purchases.length > 0 &&
                        purchases.map((purchase) => {
                          if (
                            purchase.purchase_id === course._id &&
                            purchase.purchaser_channelid != user.channelid &&
                            purchase.gifted_user_channelid != user.channelid
                          ) {
                            return (
                              <div>
                                {isAuthenticated && (
                                  <div className="action-items-stream-alt">
                                    <div
                                      className="action-button red"
                                      onClick={() =>
                                        setShowPurchaseCourse(true)
                                      }
                                    >
                                      <i className="fas fa-credit-card action-icon-alt fa-lg"></i>
                                    </div>
                                    <p className="action-text">Purchase</p>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        })}
                      {isAuthenticated &&
                        purchases &&
                        purchases.length === 0 && (
                          <div>
                            {isAuthenticated && (
                              <div className="action-items-stream-alt">
                                <div
                                  className="action-button red"
                                  onClick={() => setShowPurchaseCourse(true)}
                                >
                                  <i className="fas fa-credit-card action-icon-alt fa-lg"></i>
                                </div>
                                <p className="action-text">Purchase</p>
                              </div>
                            )}
                          </div>
                        )}
                      {isAuthenticated && user.role !== "employer" && (
                        <div className="action-items-stream">
                          <div
                            className="action-button red"
                            onClick={() => setShowGiftCourse(true)}
                          >
                            <i className="fas fa-gift action-icon-alt fa-lg"></i>
                          </div>
                          <p className="action-text">Gift Course</p>
                        </div>
                      )}
                      <StreamSecondaryLogo />
                    </div>
                  </div>
                </div>
                <div className="stream-section-container">
                  <div className="padding-container">
                    <div className="title-container-info">
                      <div className="border-alt red">
                        <p className="online-title-alt red">Course Info</p>
                      </div>
                    </div>
                    <p className="stream-desc-paragraph">
                      {course.coursedescription}
                    </p>
                  </div>
                </div>
                <MentorChatRules />
                <MentorStreamSchedule />
                <AboutMentor />
                <MentorSocial profile={profile} />
                <Approvals />
              </div>
            </div>
          </div>
          {showChat && (
            <CourseComments
              comments={course.comments}
              setShowChat={setShowChat}
              showChat={showChat}
              purchases={purchases}
              course={course}
              text={text}
              setText={setText}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

Course.propTypes = {
  auth: PropTypes.object.isRequired,
  purchase: PropTypes.object.isRequired,
  getCourseById: PropTypes.func.isRequired,
  getCourseByIdNoAuth: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  getPurchases: PropTypes.func.isRequired,
  addCourseComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  course: state.course,
  purchase: state.purchase,
});

export default connect(mapStateToProps, {
  getCourseById,
  getCourseByIdNoAuth,
  getProfileById,
  getPurchases,
})(Course);
